import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from '@src/hooks/usePermissions';
import {
    EffectivePermissions,
    PermissionRole,
} from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';
import { ROUTE_AUTH_FULL_PATH } from '@src/constants/URLS.const';

interface ProtectedRouteProps {
    permissionKey?: keyof EffectivePermissions;
    fallbackPath?: string;
    children?: React.ReactNode;
    allowedRoles?: PermissionRole[];
}

export function ProtectedRoute({
    permissionKey,
    fallbackPath = '/dashboard',
    children,
    allowedRoles = ['admin', 'viewer'],
}: ProtectedRouteProps) {
    const { permissionOf, isAuthenticated } = usePermissions();

    if (!isAuthenticated) return <Navigate to={ROUTE_AUTH_FULL_PATH} replace />;

    if (!permissionKey) return children ? <>{children}</> : <Outlet />;

    const role = permissionOf(permissionKey);

    if (!role || !allowedRoles.includes(role)) {
        return <Navigate to={fallbackPath} replace />;
    }

    return children ? <>{children}</> : <Outlet />;
}
